import React, { useEffect, useState } from "react";
import { useFormik } from "formik"
import ToastDialog from "components/Common/ToastDialog";
import 'react-confirm-alert/src/react-confirm-alert.css';
import CommonDialog from "components/Common/CommonDialog";

import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Form,
    FormFeedback,
    Input,
} from "reactstrap";
import * as Yup from "yup"

import { callGetAllWorkflow, callAddWorkflow, callEditWorkflow, callDeleteWorkflow } from "../../http/fundLync/workflow.helper";
import { getDropDownList } from "../../http/fundLync/dropdown.helper"
import { getRole } from "../../http/fundLync/role.helper"
import { uId } from "common/utility";

const WorkflowList = props => {

    document.title = "Workflow | FundLync";
    const [workflowList, setWorkflowList] = useState([]);
    const [editList, setEditList] = useState([]);
    const [isEdit, setIsEdit] = useState(false)
    const [sourceRoleList, setSourceRoleList] = useState([])
    const [targetRoleList, setTargetRoleList] = useState([])
    const [workFlowTypeList, setWorkFlowTypeList] = useState([])
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });


    useEffect(() => {
        CallValues()
        getDropDownList({ dropdownName: "workflow_type" })
            .then((response) => {
                const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "workflow_type")?.dropdownValues || []
                setWorkFlowTypeList(dropdownValues)
            })
            .catch((error) => {

            });
        getRole()
            .then((response) => {
                if (response.status) {
                    setSourceRoleList(response.data.data)
                    setTargetRoleList(response.data.data)
                }
            })
            .catch((error) => {

            });
    }, []);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            id: (isEdit && editList && editList.id) || "",
            sourceRole: (isEdit && editList && editList.sourceRole) || "",
            targetRole: (isEdit && editList && editList.targetRole) || "",
            actionType: (isEdit && editList && editList.actionType) || "",
            workflowType: (isEdit && editList && editList.workflowType) || ""
        },
        validationSchema: Yup.object({
            sourceRole: Yup.string().required("Please Select Source Role"),
            targetRole: Yup.string().required("Please Select Target Role"),
            actionType: Yup.string().required("Please Select  Action Type"),
            workflowType: Yup.string().required("Please Select Workflow Type"),
        }),
        onSubmit: values => {
            if (isEdit) {
                const updateWorkflow = {
                    id: values.id,
                    sourceRole: values.sourceRole,
                    targetRole: values.targetRole,
                    actionType: values.actionType,
                    workflowType: values.workflowType,
                }
                callEditWorkflow(updateWorkflow)
                    .then((response) => {
                        if (response.status) {
                            setToastInfo({
                                message: response.message,
                                showToast: true,
                                role: "success",
                            });
                            setIsEdit(false)
                            CallValues()
                        } else {
                            setToastInfo({
                                message: response.message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((error) => {

                    });
                validation.resetForm()
            } else {
                const newWorkflow = {
                    sourceRole: values.sourceRole,
                    targetRole: values.targetRole,
                    actionType: values.actionType,
                    workflowType: values.workflowType,
                }
                callAddWorkflow(newWorkflow)
                    .then((response) => {
                        if (response.status) {
                            setToastInfo({
                                message: response.message,
                                showToast: true,
                                role: "success",
                            });
                            CallValues()
                        } else {
                            setToastInfo({
                                message: response.message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch((error) => {

                    });
                validation.resetForm()
            }
        },
    })

    const EditWorkflow = (ele) => {
        setIsEdit(true)
        setEditList(ele)
    }

    const DeleteWorkflow = (ele) => {
        callDeleteWorkflow({ id: ele.id }).then((response) => {
            if (response.status) {
                CallValues()
            }
        })
            .catch((error) => {

            });
    }

    const CallValues = () => {
        callGetAllWorkflow()
            .then((response) => {
                if (response.status) {
                    const groupedWorkflows = {};
                    response.data.data.forEach((ele, index) => {
                        const workflowType = ele.workflowType;
                        if (!groupedWorkflows[workflowType]) {
                            groupedWorkflows[workflowType] = [];
                        }
                        groupedWorkflows[workflowType].push(ele);
                    });
                    setWorkflowList(groupedWorkflows)
                }
            })
            .catch((error) => {

            });
    }

    const capitalizeFirstLetter = (inputString) => {
        if (typeof inputString !== 'string' || inputString.length === 0) {
            return inputString;
        }
        return inputString.charAt(0).toUpperCase() + inputString.slice(1);
    }


    const handleCancel = () => {
        setIsEdit(false)
        validation.resetForm()
    }

    const dialogAction = (action, data) => {
        if(data.type == 'delete'){
            if (action == 1) {
                DeleteWorkflow(data.ele)
                setShowCommonDialog({ isShow: false })
            } else {
                setShowCommonDialog({ isShow: false })
            }
        }else{
            if (action == 1) {
                setShowCommonDialog({ isShow: false })
                validation.handleSubmit();
            } else {
                setShowCommonDialog({ isShow: false })
            }
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <h4 className="mb-4">Create WorkFlow</h4>
                    <Row className="vertical-scroll">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <Form
                                            onSubmit={e => {
                                                e.preventDefault()
                                                let message = isEdit ? 'Are you sure want to edit Workflow?' : 'Are you sure want to Save Workflow?'
                                                setShowCommonDialog({ isShow: true, data: { type: 'save' }, message: message })
                                                return false
                                            }}
                                        >
                                            <div className="mb-3 row">
                                                <Col sm="12" md="6" lg="3" className="mb-2">
                                                    <Input
                                                        name="workflowType"
                                                        type="select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.workflowType || ""}
                                                        invalid={
                                                            validation.touched.workflowType && validation.errors.workflowType
                                                        }
                                                    >
                                                        <option value="" disabled>Workflow Type</option>
                                                        {workFlowTypeList.map((option, index) => (
                                                            <option key={uId()} value={option.dropdownValue}>
                                                                {option.displayName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                    {validation.touched.workflowType && validation.errors.workflowType ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.workflowType}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>

                                                <Col sm="12" md="6" lg="3" className="mb-2">
                                                    <Input
                                                        name="sourceRole"
                                                        type="select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.sourceRole || ""}
                                                        invalid={
                                                            validation.touched.sourceRole && validation.errors.sourceRole
                                                        }
                                                    >
                                                        <option value="" disabled>Source Role</option>
                                                        {sourceRoleList.map((option, index) => (
                                                            <option key={uId()} value={option.id}>
                                                                {option.displayName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                    {validation.touched.sourceRole && validation.errors.sourceRole ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.sourceRole}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>

                                                <Col sm="12" md="6" lg="3" className="mb-2">
                                                    <Input
                                                        name="actionType"
                                                        type="select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.actionType || ""}
                                                        invalid={
                                                            !!(validation.touched.actionType && validation.errors.actionType)
                                                        }
                                                    >
                                                        <option value="" disabled>Action Type</option>
                                                        <option value="create">Create</option>
                                                        <option value="approve">Approve</option>
                                                        <option value="pushback">Push Back</option>
                                                        <option value="reject">Reject</option>
                                                        <option value="E-Sign">E-Sign</option>
                                                        <option value="Submit">Submit</option>
                                                        <option value="partner">Partner Create</option>

                                                    </Input>
                                                    {validation.touched.actionType && validation.errors.actionType ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.actionType}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>

                                                <Col sm="12" md="6" lg="3" className="mb-2">
                                                    <Input
                                                        name="targetRole"
                                                        type="select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.targetRole || ""}
                                                        invalid={
                                                            validation.touched.targetRole && validation.errors.targetRole
                                                        }
                                                    >
                                                        <option value="" disabled>Target Role</option>
                                                        {targetRoleList.map((option) => (
                                                            <option key={uId()} value={option.id}>
                                                                {option.displayName}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                    {validation.touched.targetRole && validation.errors.targetRole ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.targetRole}
                                                        </FormFeedback>
                                                    ) : null}
                                                </Col>

                                                <Col sm="12" md="12" lg="12" className="mb-2">
                                                    <div className="d-flex gap-3 justify-content-end">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-success save-customer"
                                                        >
                                                            Save
                                                        </button>
                                                        {isEdit && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-secondary"
                                                                onClick={handleCancel}
                                                            >
                                                                Cancel
                                                            </button>
                                                        )}
                                                    </div>
                                                </Col>
                                            </div>
                                        </Form>
                                    </Col>
                                </Row>
                                <p className="font-size-16">Work Flows</p>

                                {Object.entries(workflowList).map(([workflowType, workflows]) => (
                                    <Card key={workflowType} style={{ padding: "10px" }}>
                                        <p className="ms-2 font-size-16">{capitalizeFirstLetter(workflowType)}</p>
                                        {workflows.map((ele, index) => (
                                            <div key={uId()}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <p>
                                                        <span className="font-size-16">Rule {index + 1}:</span> If {ele.sourceRoleRole.display_name} {ele.actionType} then {workflowType} will go to {ele.targetRoleRole.display_name}
                                                    </p>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p style={{ cursor: "pointer" }} onKeyUp={()=>{}} onClick={e => { EditWorkflow(ele) }}>
                                                            <i className="mdi mdi-pencil font-size-18 text-success me-1" id="edittooltip"></i>
                                                        </p>
                                                        <p style={{ cursor: "pointer" }} onKeyUp={()=>{}} onClick={e => {
                                                            setShowCommonDialog({ isShow: true, data: { type: 'delete' , ele}, message: 'Are you sure want to delete Workflow?' })
                                                        }}>
                                                            <i className="mdi mdi-delete font-size-18 text-success me-1" id="edittooltip"></i>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Card>
                                ))}

                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
            {showCommonDialog &&
                <CommonDialog isShow={showCommonDialog.isShow} header={''} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogAction}></CommonDialog>
            }
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </React.Fragment>
    );
};



export default WorkflowList;
